<template>
  <!-- Kundenfeedback KS 29.10.2026, I: Die Adressen im Organigramm sind zugleich
       die Postfächer für KARS-E-Mails. Der Hinweis führt zum zentralen Ort.
       Nur im Organigramm – in der Registrierung würde der Link hinausführen. -->
  <p v-if="$route.name === 'PageOrganization'" class="msh" data-testid="mailbox-settings-hint">
    <Inbox aria-hidden="true" :size="13" />
    <span>
      {{ $gt('Diese Adresse dient auch als Postfach für KARS-E-Mails.') }}
      <router-link class="msh__link" :to="{ name: 'PageCommunicationSettings', query: { bereich: 'postfaecher' } }">
        {{ $gt('Alle Postfächer an einem Ort') }}
      </router-link>
    </span>
  </p>
</template>

<script setup lang="ts">
  import { Inbox } from 'lucide-vue-next'
</script>

<style lang="scss" scoped>
.msh {
  display: flex; gap: 6px; margin: 6px 0 0;
  font-size: 0.74rem; line-height: 1.45; color: var(--grey-color, #5f5f5f);
  svg { flex-shrink: 0; margin-top: 2px; }
}
.msh__link {
  font-weight: 600; color: var(--primary-color, #0076e5); text-decoration: underline; text-underline-offset: 2px;
  &:focus-visible { outline: 2px solid var(--primary-color, #0076e5); outline-offset: 2px; }
}
</style>
